import { observer } from "mobx-react-lite";

import HomeLoggedOut from "./HomeLoggedOut";
import HomeLoggedIn from "./HomeLoggedIn";
import { UserProps } from "stores/user_store";

const HomeDealer = observer(({ currentUser }: { currentUser: UserProps }) => {
    if(!currentUser?.key) {
        return <HomeLoggedOut  />;
    }
    else {
        return <HomeLoggedIn  />;
    }
});

export default HomeDealer;
